@if (imageLoaded) {
  <div
    class="fs-block fs-exclude background-image"
    #highlightedImgId
    [ngStyle]="imageStyles"
    >
    @for (highlight of displayHighlights; track trackHighlightById($index, highlight)) {
      <div class="text-highlight"
        [attr.data-highlight-id]="highlight.id"
        [ngClass]="{'active': highlight.id === activeHighlightId}"
        [style.left.px]="highlight.left"
        [style.top.px]="highlight.top"
        [style.width.px]="highlight.width"
        [style.height.px]="highlight.height"
      ></div>
    }
    @if (cropper) {
      <div class="cropper"
        #cropper
        [style.left.px]="xcoord"
        [style.top.px]="ycoord"
        [style.width.px]="width"
        [style.height.px]="height"
        >
      </div>
    }
  </div>
} @else {
  <div class="image-placeholder" [style.height.px]="imagePlaceholderHeight">
    @if (!imageFailedToLoad) {
      <div class="loader"></div>
    } @else {
      <i class="fa fa-circle-exclamation"></i>
    }
  </div>
}
